import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-premiere-background-image',
  templateUrl: './premiere-background-image.component.html',
  styleUrls: ['./premiere-background-image.component.css']
})
export class PremiereBackgroundImageComponent implements OnInit {

  @Input('premiereDetails') premiereDetails:any;
  eventImage:any
  constructor() { }

  ngOnInit(): void {
    this.eventImage =this.premiereDetails.eventImage
    if(this.eventImage === ""){
    this.eventImage = "assets/images/spotlight/image-not-found.png";
      }
  }
back(){
  history.back()
}
  
}
